// Copyright (c) 2019 Deere & Company

export const BaseCodeColumnDefinitions = [

    {

        field: 'baseCodeName',
        headerName: 'Base Code',
        sortable: true,
        filter: true,
        width: 200,

    },
    {

        field: 'productSubSeriesName',
        headerName: 'Product Sub Series',
        sortable: true,
        filter: true,
        width: 250,

    },
    {

        field: 'productSeriesName',
        headerName: 'Product Series',
        sortable: true,
        filter: true,
        width: 250,

    },
];
